import { library } from '@fortawesome/fontawesome-svg-core'
import { faLock } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from '@lingui/macro'
import Paragraph from 'Root/App/Paragraph'
import Title from 'Root/App/Title'

import Chip from '../Chip'

library.add(faLock)

interface PrivateBoxProps {
  active?: boolean
  onClick?: () => void
}

const BoxIcon = () => (
  <span className="flex justify-center items-center bg-gray-200 w-10 h-10 min-w-10 rounded-lg">
    <FontAwesomeIcon className="text-sm text-gray-500" icon={['fas', 'lock']} />
  </span>
)

const PrivateBox = ({ active, onClick }: PrivateBoxProps) => {
  return (
    <Chip
      icon={<BoxIcon />}
      highlight
      highlightCustomClass="p-3"
      active={active}
      onClick={onClick}
    >
      <span>
        <Title size="2XS">
          <Trans>Bloccato</Trans>
        </Title>
        <Paragraph className="text-gray-500 sm:max-w-xs">
          <Trans>
            Solo tu e le persone autorizzate possono accedere al contenuto.
          </Trans>
        </Paragraph>
        <Paragraph size="XS" className="text-gray-500 sm:max-w-xs">
          <Trans>
            Utilizza questa opzione, ad esempio, per i contenuti che devono
            essere visibili solo dopo l&apos;acquisto del tuo corso.
          </Trans>
        </Paragraph>
      </span>
    </Chip>
  )
}

export default PrivateBox
